import styled from 'styled-components';

export const TimelineCarouselWrapper = styled.div`
  max-width: 100%;

  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;

    &:not(:last-child) {
      margin-right: 4px;

      @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
        margin-right: 12px;
      }
    }
  }

  .swiper-virtual {
    display: flex;
  }

  .swiper-slide-virtual {
    transform: translateZ(0);
  }
`;
